define('modules/form/select_view',[
  'backbone',
  'jquery',
  '_',

  './form_item_view',
  'modules/form/convert-form-data',

  'text!./select_template.html',
  'text!./select_tags_template.html',
  'text!modules/form/media_fact_connection/media_fact_connection_template.html',
  'selectize'

], function(Backbone, $, _, FormItemView, convertFormData, template, tags_template, media_fact_connection_template) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function(options) {
      _.extend(this, options);

      this.listenTo(Backbone, 'render:form', function() {

        // FIXME: try to only run this once...
        $('select.tags').selectize({
          plugins: ['remove_button'],
          delimiter: ',',
          persist: false
        });
      }, this);

      this.listenTo(this.model, 'change', this.renderMediaFactConnection);

      FormItemView.prototype.initialize.apply(this, options);
      var values = {};

      values[this.model.get('name')] = this.getValues();

      this.dataModel.set(values);
      this.dataModelAttributesOriginal = _.cloneDeep(this.dataModel.attributes);

      this.render();
      this.renderMediaFactConnection();
    },
    media_fact_connection_template: _.template(media_fact_connection_template),
    events: {
      'change select': 'handleChange',
      'focus select': 'triggerFocus',
      'blur select': 'triggerBlur'
    },

    triggerFocus: function() {
      this.dataModel.trigger('has-focus');
    },

    triggerBlur: function() {
      this.dataModel.trigger('lost-focus');
    },

    getValues: function() {

        var values = [];

        _.forEach(this.model.get('options'), function(option) {
          if (option.state === 'active') {
            values.push(option.value);
          }
        });

        return this.model.get('type') === 'select' ? values[0] : values;
    },

    handleChange: function (e) {
      var property = e.target.name.split('[')[0];

      this.dataModel.trigger('lost-focus');
      this.dataModel.set(property, $(e.target).val());
      
      if (this.model.get('media_fact_connection') === 'Connected') {
        this.model.set('media_fact_connection', 'WillDisconnect');
      }
      // Reset to 'Connected' if user changes back to the original value.
      else if (this.model.get('media_fact_connection') === 'WillDisconnect'
        && $(e.target).val() === this.dataModelAttributesOriginal[property]) {
        this.model.set('media_fact_connection', 'Connected');
      }
    },

    template: null,

    renderMediaFactConnection: function () {
      this.$('.js-media-fact-connection').html(this.media_fact_connection_template(this.model.attributes));
      return this;
    },

    render: function () {
      this.template = this.model.get('type') === 'tags' ? _.template(tags_template) : _.template(template);
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    remove: function() {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

